/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs */

const en_forms_rule_sets_edit_open_contact_detail_before_accepting = /** @type {(inputs: Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Contact Detail Before Accepting`)
};

const de_forms_rule_sets_edit_open_contact_detail_before_accepting = /** @type {(inputs: Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen vor Annahme öffnen`)
};

/**
* | output |
* | --- |
* | "Open Contact Detail Before Accepting" |
*
* @param {Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_open_contact_detail_before_accepting = /** @type {((inputs?: Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_Open_Contact_Detail_Before_AcceptingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_open_contact_detail_before_accepting(inputs)
	return de_forms_rule_sets_edit_open_contact_detail_before_accepting(inputs)
});